module.exports = __webpack_public_path__ + "img/house-arrow.e32103f0.svg";